<div>
  <div class="grid-x grid-margin-x headline-wrapper">
    <div class="cell small-12 large-12">
      <dialog-hint [showPdfAndPrintIcons]="false" textkey="stancheck.haushalt.ergebnis.callout"  remeberCloseId="moc-result-hint" [closable]="true"></dialog-hint>
    </div>
    <div class="cell small-12 large-offset-1 large-10 text-center">
      <h1 [innerHTML]="'stancheck.haushalt.ergebnis.headline' | translate"></h1>
    </div>
  </div>

  <div class="grid-x grid-margin-x">
    <div class="cell small-12 large-offset-2 medium-offset-1 medium-10 large-8">
      <h3 [innerHTML]="'stancheck.haushalt.ergebnis.uelektronik.header' | translate"></h3>
      <p [innerHTML]="('stancheck.haushalt.ergebnis.uelektronik.text') | translate"></p>
    </div>
  </div>

    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-10 medium-offset-1">
        <div class="button-wrapper background">
          <form (submit)="onSubmit()" class="step-form">
            <app-step-buttons previousLink="../9" nextText="stancheck.haushalt.ergebnis.submit"
                              [nextLink]="'../../../ergebnis'" [nextSubmit]="true"
                              largeOffset="0" mediumWidthRight="auto" largeWidthRight="auto"
                              [nextClass]="loadingData? 'loading' : ''"></app-step-buttons>
          </form>
        </div>
      </div>
    </div>

  </div>
